import { useEffect, useState, useCallback } from "react";
import { forceLogout } from "./useSettings";

const NOTICE_KEY = "cookie_notice.acknowledged";

const listeners = new Set();
let acknowledged = null;

function readAck() {
  try {
    return localStorage.getItem(NOTICE_KEY) === "true";
  } catch {
    return false;
  }
}

function notify(v) {
  acknowledged = v;
  listeners.forEach((l) => l(v));
}

export function useCookieNotice() {
  const [state, setState] = useState({
    loaded: acknowledged !== null,
    visible: acknowledged === false,
  });

  useEffect(() => {
    if (acknowledged === null) {
      acknowledged = readAck();
      setState({ loaded: true, visible: !acknowledged });
    }
    const l = (v) => setState({ loaded: true, visible: !v });
    listeners.add(l);
    return () => {
      listeners.delete(l);
    };
  }, []);

  const acknowledge = useCallback(() => {
    try {
      localStorage.setItem(NOTICE_KEY, "true");
    } catch {
      /* ignore */
    }
    notify(true);
  }, []);

  const reopen = useCallback(() => {
    notify(false);
  }, []);

  return { loaded: state.loaded, visible: state.visible, acknowledge, reopen };
}

export async function clearLocalPreferences() {
  await forceLogout();
  try {
    localStorage.removeItem(NOTICE_KEY);
  } catch {
    /* ignore */
  }
  notify(false);
}

let reopenNotice = () => {};
export function registerReopenNotice(fn) {
  reopenNotice = fn;
}
export function triggerReopenNotice() {
  reopenNotice();
}
